import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { resetOrderCreation, resetRestaurantOrder } from "../redux/restaurantOrderActions";
import { resetOrderCreation as resetBrandOrderCreation, resetBrandOrder } from "../redux/brandOrderActions";
import { resetPaymentStatus } from "../redux/paymentRedux";
import { resetRestaurantCart } from "../redux/restaurantCartSlice";
import { clearCart } from "../redux/brandCartSlice";
import { createUserSocket } from "../utils/userSocket";
import useBlockBackNavigation from "../hooks/useBlockBackNavigation";
import { pickLatestOrder } from "../utils/pickLatestOrder";
import Navbar from "../components/Navbar";
import OrderConfirmation from "../components/Order/OrderConfirmation";
import "./Modals/momoModal.css";
import { resetRetailerWholesalerCart } from "../redux/retailerWholesalerCartSlice";

const MomoOrderScreen = () => {
  const user = useSelector((state) => state.user.currentUser);
  const { order } = useSelector((state) => state.orders);
  const restaurantOrder = useSelector((state) => state.restaurantOrder.order);
  const retailWholesalerOrder = useSelector((state) => state.retailerWholesalerOrder.order);
  const brandOrder = useSelector((state) => state.brandOrder.order);
  const healthcareOrder = useSelector((state) => state.healthcareOrder?.order);
  // Value intentionally unread: the payment banner moved into
  // OrderConfirmation's paymentSlot, but the socket handler below still records
  // the last message for future use.
  const [, setPaymentStatus] = useState(null);
  
  /* Newest wins — see pickLatestOrder. The old chain led with brandOrder, and
     none of these slices is cleared between checkouts, so a restaurant order
     placed after a brand order in the same session rendered the brand one. */
  const activeOrder =
    pickLatestOrder([
      brandOrder,
      restaurantOrder,
      retailWholesalerOrder,
      healthcareOrder,
      order,
    ]) || order;

  const client_id = user?.result?._id || user?._id;
  const dispatch = useDispatch();
  const history = useHistory();

  // Back must not return into the checkout flow (double-order protection).
  useBlockBackNavigation("/");

  const handleContinueShopping = () => {
    dispatch(resetOrderCreation());
    dispatch(resetBrandOrderCreation());
    dispatch(resetBrandOrder());
    dispatch(resetPaymentStatus());
    dispatch(resetRestaurantCart());
    dispatch(resetRetailerWholesalerCart());
    // Clear the cart of the order on screen, not of a stale brand order.
    dispatch(clearCart(activeOrder?.vendorId || null));
    dispatch(resetRestaurantOrder());
    history.push("/");
  };

  useEffect(() => {
    // Carries the customer's token: their rooms need it (utils/userSocket.js).
    const socket = createUserSocket();

    socket.on("connect", () => {
      console.log("Socket connected...");
      // The handler reads `data.client_id`; a bare id was an error reply.
      socket.emit("subscribeToPaymentStatus", { client_id });
    });

    socket.on("paymentStatusUpdate", (data) => {
      setPaymentStatus(data.msg);

      if (data.msg === "Transaction Successful" || data.msg === "Transaction Failed") {
        socket.disconnect();
      }
    });

    socket.on("disconnect", () => {
      console.log("WebSocket disconnected");
    });

    return () => {
      socket.disconnect();
      dispatch(resetOrderCreation());
      dispatch(resetBrandOrderCreation());
      dispatch(resetPaymentStatus());
      dispatch(resetRestaurantCart());
      dispatch(resetRetailerWholesalerCart());
      dispatch(resetRestaurantOrder());
    };
  }, [client_id, dispatch]);


  return (
    <>
      <Navbar />
      <OrderConfirmation
        order={activeOrder}
        paymentLabel={"MTN MoMo"}
        onContinueShopping={handleContinueShopping}
      />
    </>
  );
};

export default MomoOrderScreen;
